import { PrivateSettings } from '@wix/wix-vod-api-site-based/privateSettings';
import { keysToSnakeCase } from '@wix/wix-vod-shared/common';
import { parseSuccessResponse } from './parsers/success-response';
import { toError } from '../../parsers/to-error';
import { PrivateSettingsService } from './settings';
export class PrivateSettingsServiceV2 extends PrivateSettingsService {
    constructor(httpClient, baseUrl) {
        super();
        this.httpClient = httpClient;
        this.get = () => this.privateSettingsService
            .getSettings()
            .then(parseSuccessResponse)
            .catch(toError);
        this.update = (settings) => {
            const dateToNumber = (ts) => ts === null || ts === void 0 ? void 0 : ts.valueOf();
            return this.privateSettingsService
                .update(keysToSnakeCase(Object.assign(Object.assign({}, settings), { createdTs: dateToNumber(settings.createdTs), updatedTs: dateToNumber(settings.updatedTs) })))
                .then(parseSuccessResponse)
                .catch(toError);
        };
        this.reset = () => this.privateSettingsService
            .reset()
            .then((response) => response.data)
            .catch(toError);
        this.privateSettingsService = new PrivateSettings(httpClient, baseUrl);
    }
}
//# sourceMappingURL=settings.v2.js.map